// 常用函数
import fp from './fp';
import { createElement } from 'react';

function getAuthDom({type, name, display, editable, event}) {
    if (!display) return;
    return createElement(
        'a',
        { key: type, disabled: !editable, onClick: !editable ? () => void undefined : event },
        name
    );
}

/**
 * 角色对应的权限列表
 * @param {Array} operationCorrespondRoles 操作对应的角色
 * @param {String} role 角色
 */
const authDomList = (operationCorrespondRoles, role) => {
    const result = [];
    for (let [type, value] of operationCorrespondRoles) {
        const { roles, ...rest } = value;
        if (roles.some(r => r === '*' || r === role)) {
            result.push(getAuthDom({ type, ...rest }));
        }
    }
    return result;
};

/**
 * 最终的操作权限列表
 * @param {ReactElement} divider 操作对应的角色
 * @param {Array} authDomList 角色对应的权限列表
 */
const operationAuthByRole = (divider, authDomList) => {
    return fp.reduce((acc, dom, index, array) => {
        acc.push(dom);
        if (index < array.length - 1) {
            acc.push(divider(index));
        }
        return acc;
    }, [])(authDomList);
};

export default { authDomList, operationAuthByRole };


// WEBPACK FOOTER //
// ./src/utils/cf.js